module.exports = __webpack_public_path__ + "media/src/images/social-g-f460da0f777f58786fa7fbce76b1354f.svg";